/**
 * Redondeo hacia arriba al múltiplo más cercano (pesos AR).
 * @param {number} value
 * @param {number} step 0 = sin redondeo
 */
export function roundUpToNearest(value, step) {
  const n = Number(value);
  const s = Number(step);
  if (!Number.isFinite(n) || n <= 0) return 0;
  if (!Number.isFinite(s) || s <= 0) return Math.round(n);
  return Math.ceil(n / s) * s;
}

export const REDONDEO_PESO_OPCIONES = [
  { value: 0, label: 'Sin redondeo' },
  { value: 10, label: '10' },
  { value: 50, label: '50' },
  { value: 100, label: '100' }
];
